import { lazyLaunchInAppFeedback } from "owa-uservoice";

export default function feedbackPaneRouteHandler(): void {
    lazyLaunchInAppFeedback.importAndExecute();
}
